module.exports = __webpack_public_path__ + "img/footer_text.9d5b3746.png";